import React from 'react';
import ImageCellView from './imageCell';
import DeleteCell from './deleteCell';
import EditableCell from './editableCell';
import EditableDateCell from './editableDateCell';
import EditableRangeDateCell from './editableRangeDateCell';
import EditableSelectCell from './editableSelectCell';
import FilterDropdown from './filterDropdown';

const DateCell = data => <p>{data.toLocaleString()}</p>;
const DateFormatCell = data => <p>{data.format('DD-MM-YYYY HH:mm')}</p>;
const ImageCell = src => <ImageCellView src={src} />;
const LinkCell = (link, href) => <a href={href ? href : '#'}>{link}</a>;
const TextCell = text => <p>{text}</p>;
const HtmlCell = text => <p dangerouslySetInnerHTML={{ __html: text }}></p>;

export {
  DateCell,
  DateFormatCell,
  ImageCell,
  LinkCell,
  TextCell,
  HtmlCell,
  EditableCell,
  EditableDateCell,
  EditableRangeDateCell,
  EditableSelectCell,
  DeleteCell,
  FilterDropdown
};
